import { Box } from "@planningcenter/tapestry-react"
import { arrayOf, number, shape, string } from "prop-types"

const Reminders = ({ reminders }) => {
  return reminders.map(reminder => (
    <Box key={reminder.id} marginTop={1} marginBottom={2}>
      <div>
        A reminder will be sent to <strong>{reminder.attendeeTypeNames}</strong> at{" "}
        {reminder.sendAtTime} on {reminder.sendAtDate} ({reminder.durationString} before the event)
        {reminder.message ? " with the follow message:" : "."}
      </div>
      {reminder.message && (
        <div
          dangerouslySetInnerHTML={{
            __html: reminder.message
          }}
          className="mt-1 action-drawer trix-readonly"
        />
      )}
    </Box>
  ))
}

Reminders.propTypes = {
  reminders: arrayOf(
    shape({
      id: number,
      sendAtTime: string,
      sendAtDate: string,
      durationString: string
    })
  )
}

export default Reminders
